export const RIGHT_COLUMN_COMPONENTS = ['preview', 'console'];
